export default __webpack_public_path__ + "static/media/icon-active.2de26763.svg";